export default __webpack_public_path__ + "static/media/bannerFeriaFlores.78c699fb.jpg";